const targetOptions = [
  {
    title: 'Nova aba',
    value: '_blank',
  },
  {
    title: 'Mesma aba',
    value: '_self',
  },
]

export default targetOptions
